import React, { useEffect, useRef, useState } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { useEnteredView } from '@fiverr-private/hooks';
import { HOLLYWOOD_DIRECTORS } from '../DirectorsSection/constants';
import { MIXPANEL_EVENTS, sendMixpanelEvent } from '../../shared/tracking';
import { FormState } from '../../types';
import { BOOKING_DIRECTOR_HINT, BOOKING_EMAIL, BOOKING_SUBTITLE, BOOKING_TITLE, INITIAL_FORM_STATE } from './constants';
import {
  directorHint,
  emailLink,
  fieldLabel,
  formGrid,
  hubspotFormContainer,
  layout,
  section,
  selectInput,
  submitButton,
  submitWrap,
  textAreaWrap,
  submitSuccess,
  subtitle,
  textArea,
  textInput,
  titleText,
  topFields,
  validationText,
} from './styles.ve.css';

const HUBSPOT_SCRIPT_URL = '//js-eu1.hsforms.net/forms/embed/v2.js';
const HUBSPOT_PORTAL_ID = '27087407';
const HUBSPOT_FORM_ID = '16dd1ca8-a758-4d8a-89a6-efc8379d01d8';
const HUBSPOT_REGION = 'eu1';
const HUBSPOT_CONTAINER_ID = 'hubspot-booking-form';

const USE_HUBSPOT_FORM = true;
const HS_STYLE_ID = 'hs-hollywood-overrides';

const getHubSpotOverrideCSS = () => {
  const s = `#${HUBSPOT_CONTAINER_ID}`;

  return `
${s} form { font-family: inherit !important; }

${s} fieldset {
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

${s} fieldset.form-columns-2 {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 112px !important;
}

${s} fieldset.form-columns-1 { margin-top: 112px !important; }
${s} fieldset + fieldset { margin-top: 112px !important; }

${s} .hs-form-field {
  display: flex !important;
  flex-direction: column-reverse !important;
  position: relative !important;
  width: 100% !important;
  max-width: none !important;
  float: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

${s} .hs-form-field > .input {
  width: 100% !important;
  max-width: none !important;
}

${s} label:not(.hs-error-msg) {
  display: block !important;
  margin-top: 2px !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  letter-spacing: -0.01em !important;
  line-height: 1.5 !important;
  color: #FFFFFF !important;
}

${s} .hs-form-required { display: none !important; }

${s} input.hs-input {
  display: block !important;
  width: 100% !important;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-bottom: 1px solid #FFFFFF !important;
  border-radius: 0 !important;
  color: #FFFFFF !important;
  padding: 0 0 4px 0 !important;
  font-size: 16px !important;
  font-family: inherit !important;
  line-height: 1.5 !important;
  outline: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  box-shadow: none !important;
}

${s} input.hs-input:focus { border-bottom-color: #C5C6C9 !important; }
${s} input.hs-input::placeholder { color: transparent !important; }

${s} input.hs-input:-webkit-autofill,
${s} input.hs-input:-webkit-autofill:hover,
${s} input.hs-input:-webkit-autofill:focus {
  -webkit-text-fill-color: #FFFFFF !important;
  -webkit-box-shadow: 0 0 0px 1000px #000000 inset !important;
  box-shadow: 0 0 0px 1000px #000000 inset !important;
  border-bottom: 1px solid #FFFFFF !important;
  caret-color: #FFFFFF !important;
}

${s} select {
  display: block !important;
  width: 100% !important;
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid #FFFFFF !important;
  border-radius: 0 !important;
  color: #FFFFFF !important;
  padding: 0 0 4px 0 !important;
  font-size: 16px !important;
  font-family: inherit !important;
  line-height: 1.5 !important;
  outline: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  box-shadow: none !important;
  cursor: pointer !important;
}
${s} select:focus { border-bottom-color: #C5C6C9 !important; }
${s} select option { color: #222325 !important; background-color: #FFFFFF !important; }

${s} textarea,
${s} textarea.hs-input {
  display: block !important;
  width: 100% !important;
  background: transparent !important;
  border: 1px solid #FFFFFF !important;
  border-radius: 8px !important;
  color: #FFFFFF !important;
  padding: 13px 17px !important;
  font-size: 16px !important;
  font-family: inherit !important;
  outline: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  box-shadow: none !important;
  resize: vertical !important;
  min-height: 303px !important;
}
${s} textarea:focus { border-color: #C5C6C9 !important; }
${s} textarea::placeholder { color: #B5B6BA !important; }

${s} .hs_submit { margin-top: 56px !important; }

${s} input[type="submit"],
${s} .hs-button {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 48px !important;
  padding: 16px 24px !important;
  background-color: #FFFFFF !important;
  background: #FFFFFF !important;
  color: #222325 !important;
  border: none !important;
  border-radius: 80px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  font-family: inherit !important;
  letter-spacing: -0.02em !important;
  line-height: normal !important;
  cursor: pointer !important;
  box-shadow: none !important;
  text-shadow: none !important;
}
${s} input[type="submit"]:hover,
${s} .hs-button:hover { opacity: 0.9 !important; }
${s} input[type="submit"]:active,
${s} .hs-button:active { opacity: 0.8 !important; }

${s} .hs-error-msgs {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  margin-top: 2px !important;
  list-style: none !important;
  padding: 0 !important;
}
${s} .hs-error-msgs li label { color: #FF4D4F !important; font-size: 12px !important; margin-top: 0 !important; }

@media screen and (min-width: 700px) {
  ${s} fieldset.form-columns-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    column-gap: 80px !important;
    row-gap: 112px !important;
  }
  ${s} input[type="submit"],
  ${s} .hs-button { height: 56px !important; font-size: 20px !important; }
}

@media screen and (min-width: 1400px) {
  ${s} fieldset.form-columns-2 { column-gap: 80px !important; row-gap: 128px !important; }
  ${s} fieldset.form-columns-1 { margin-top: 128px !important; }
  ${s} fieldset + fieldset { margin-top: 128px !important; }
  ${s} input.hs-input { font-size: 22px !important; letter-spacing: -0.03em !important; }
  ${s} input[type="submit"],
  ${s} .hs-button { height: 72px !important; font-size: 24px !important; }
}

@media screen and (min-width: 1760px) {
  ${s} label:not(.hs-error-msg) { font-size: 18px !important; }
  ${s} input.hs-input { font-size: 24px !important; }
  ${s} textarea, ${s} textarea.hs-input { border-radius: 16px !important; font-size: 18px !important; }
}

${s} .submitted-message p {
  line-height: 1.5 !important;
  font-family: inherit !important;
  font-size: 21px !important;
  margin-top: 27px !important;
  color: #FFFFFF !important;
}
`.trim();
};

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: {
          portalId: string;
          formId: string;
          region: string;
          target: string;
          onFormSubmitted?: () => void;
          onFormReady?: ($form: unknown) => void;
        }) => void;
      };
    };
  }
}

type FormErrors = Partial<Record<keyof FormState, string>>;

const OldBookingForm: React.FC = () => {
  const [formState, setFormState] = useState<FormState>(INITIAL_FORM_STATE);
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [isSubmitMessageVisible, setIsSubmitMessageVisible] = useState(false);

  const setFieldValue = <T extends keyof FormState>(field: T, value: FormState[T]) => {
    setFormState((previousState) => ({ ...previousState, [field]: value }));
    setFormErrors((previousState) => ({ ...previousState, [field]: '' }));
    setIsSubmitMessageVisible(false);
  };

  const validateForm = (): FormErrors => {
    const errors: FormErrors = {};

    if (!formState.fullName.trim()) {
      errors.fullName = 'Full name is required';
    }
    if (!formState.budget.trim()) {
      errors.budget = 'Budget is required';
    }
    if (!formState.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formState.email)) {
      errors.email = 'Please enter a valid email';
    }

    return errors;
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({});
    setIsSubmitMessageVisible(true);
  };

  return (
    <form className={formGrid} onSubmit={onSubmit}>
      <div className={topFields}>
        <div>
          <input
            id="hollywood-full-name"
            className={textInput}
            type="text"
            value={formState.fullName}
            onChange={(event) => setFieldValue('fullName', event.currentTarget.value)}
          />
          <label className={fieldLabel} htmlFor="hollywood-full-name">
            Full name*
          </label>
          {formErrors.fullName ? <p className={validationText}>{formErrors.fullName}</p> : null}
        </div>

        <div>
          <input
            id="hollywood-budget"
            className={textInput}
            type="text"
            value={formState.budget}
            onChange={(event) => setFieldValue('budget', event.currentTarget.value)}
          />
          <label className={fieldLabel} htmlFor="hollywood-budget">
            Budget*
          </label>
          {formErrors.budget ? <p className={validationText}>{formErrors.budget}</p> : null}
        </div>

        <div>
          <input
            id="hollywood-email"
            className={textInput}
            type="email"
            value={formState.email}
            onChange={(event) => setFieldValue('email', event.currentTarget.value)}
          />
          <label className={fieldLabel} htmlFor="hollywood-email">
            Email*
          </label>
          {formErrors.email ? <p className={validationText}>{formErrors.email}</p> : null}
        </div>

        <div>
          <select
            id="hollywood-director"
            className={selectInput}
            value={formState.directorId}
            onChange={(event) => setFieldValue('directorId', event.currentTarget.value)}
          >
            <option value=""> </option>
            {HOLLYWOOD_DIRECTORS.map((director) => (
              <option key={director.id} value={director.id}>
                {director.name}
              </option>
            ))}
          </select>
          <label className={fieldLabel} htmlFor="hollywood-director">
            Chose your director*
          </label>
          <p className={directorHint}>{BOOKING_DIRECTOR_HINT}</p>
        </div>
      </div>

      <div className={textAreaWrap}>
        <textarea
          id="hollywood-description"
          className={textArea}
          value={formState.projectDescription}
          onChange={(event) => setFieldValue('projectDescription', event.currentTarget.value)}
          placeholder="Project description"
        />
      </div>

      <div className={submitWrap}>
        <button type="submit" className={submitButton}>
          Submit
        </button>
        {isSubmitMessageVisible ? (
          <p className={submitSuccess}>Form is valid and ready. Submission endpoint will be connected next.</p>
        ) : null}
      </div>
    </form>
  );
};

const BookingSection = React.forwardRef<HTMLDivElement>((_props, ref) => {
  const initializedRef = useRef(false);
  const trackingRef = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  useEnteredView(trackingRef, {
    threshold: 0.1,
    onEntered: () => {
      sendMixpanelEvent({ eventName: MIXPANEL_EVENTS.BOOKING_SECTION_VIEWED });
      setIsInView(true);
    },
  });

  useEffect(() => {
    if (!USE_HUBSPOT_FORM || !isInView || initializedRef.current) {
      return undefined;
    }

    initializedRef.current = true;

    const createForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: HUBSPOT_PORTAL_ID,
          formId: HUBSPOT_FORM_ID,
          region: HUBSPOT_REGION,
          target: `#${HUBSPOT_CONTAINER_ID}`,
          onFormSubmitted: () => {
            sendMixpanelEvent({ eventName: MIXPANEL_EVENTS.FORM_SUBMITTED });
          },
          onFormReady: () => {
            const container = document.getElementById(HUBSPOT_CONTAINER_ID);
            if (!container) return;

            if (!document.getElementById(HS_STYLE_ID)) {
              const style = document.createElement('style');
              style.id = HS_STYLE_ID;
              style.textContent = getHubSpotOverrideCSS();
              document.head.appendChild(style);
            }

            container.querySelectorAll('fieldset').forEach((fieldset) => {
              const visible = fieldset.querySelectorAll(
                '.hs-form-field:not([style*="display: none"]):not([style*="display:none"])'
              );
              if (visible.length === 0) {
                (fieldset as HTMLElement).style.display = 'none';
                (fieldset as HTMLElement).style.margin = '0';
              }
            });
          },
        });
      }
    };

    if (window.hbspt) {
      createForm();

      return undefined;
    }

    const script = document.createElement('script');
    script.src = HUBSPOT_SCRIPT_URL;
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = createForm;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [isInView]);

  return (
    <Container className={section} ref={ref}>
      <Container ref={trackingRef} className={layout}>
        <div>
          <h2 className={titleText}>{BOOKING_TITLE}</h2>
          <p className={subtitle}>
            {BOOKING_SUBTITLE}
            {'\n'}
            <a href={`mailto:${BOOKING_EMAIL}`} className={emailLink}>
              {BOOKING_EMAIL.toUpperCase()}
            </a>
          </p>
        </div>

        {USE_HUBSPOT_FORM ? <div id={HUBSPOT_CONTAINER_ID} className={hubspotFormContainer} /> : <OldBookingForm />}
      </Container>
    </Container>
  );
});

BookingSection.displayName = 'BookingSection';

export default BookingSection;
